import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import Loader from "../../../../Base/Components/Loader/Loader";

import QRCode from "qrcode";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const QRCodeModal = ({ showDialogQRCode, selected, setShowDialogQRCode, getInfo, setSelected, setSelectedQR , etiquetaTipo,}) => {
  const [loading, setLoading] = useState(true);
  const [pdfUrl, setPdfUrl] = useState(null);

  
  const onHideReporte = () => {
    setShowDialogQRCode(false);
    getInfo()
    setSelected([])
    setSelectedQR([])
  };
  
  const obtenerInformacion = (selected) => {
    setLoading(true)
    if (selected.length > 0) {
      if(etiquetaTipo === 1){
        GenerarReportePDF4x3(selected)
      }else if(etiquetaTipo === 2){
        GenerarReportePDF6x4(selected)
      }else if(etiquetaTipo === 3){
        GenerarReportePDF4x1(selected);
      }
    }
    setLoading(false)
  };
  
  const GenerarReportePDF4x1 = (selected) => {
    const contenido = [];

    selected.forEach((activo, index) => {
      QRCode.toDataURL(
        `${activo?.CodigoActivo}`,
        { errorCorrectionLevel: "Q" },
        (err, url) => {
          if (err) {
            console.error("Error generando el código QR:", err);
            return;
          }
  
          const CodigoQR = url;
  
          contenido.push({
            columns: [
              {
                margin: [-5, -4, 0, 0],
                table: {
                  widths: ["*"],
                  body: [
                    [
                      {
                        image: CodigoQR,
                        width: 75,
                        height: 75,
                      },
                    ],
                  ],
                },
                layout: {
                  defaultBorder: false,
                },
              },
              {
                margin: [-50, 7, 5, 0],
                table: {
                  widths: ["*"],
                  body: [
                    [
                      {
                        text: `${activo?.CodigoActivo || ''}`,
                        style: "titulo1",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: `${activo?.NombreActivo.substring(0, 82) || ""}`,
                        style: "infoGeneral",
                      },
                    ],
                    [
                      {
                        text: `- ${activo?.Type || ''} -`,
                        style: "infoGeneral2",
                        margin: [0, 2, 0, 0],
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },
            ],
          },
          index < selected.length - 1 ? { text: '', pageBreak: 'after' } : null);
        }
        
      );
    })

    const docDefinition = {
      pageSize: {
        width: 288,
        height: 72,
      },
      styles: {
        titulo1: {
          fontSize: 11,
          bold: true,
          alignment: "center",
        },
        infoGeneral: {
          fontSize: 9,
          bold: true,
          alignment: "center",
        },
        infoGeneral2: {
          fontSize: 9,
          alignment: "center",
        },
      },
      pageMargins: [10, 0, 10, 0],
      content: contenido,
    };

    const doc = pdfMake.createPdf(docDefinition);
    
    doc.getDataUrl((url) => {
      setPdfUrl(url); 
    });
  };

  const GenerarReportePDF6x4 = (selected) => {
    const contenido = [];

    selected.forEach((activo, index) => {
      QRCode.toDataURL(
        `${activo?.CodigoActivo}`,
        { errorCorrectionLevel: "Q" },
        (err, url) => {
          if (err) {
            console.error("Error generando el código QR:", err);
            return;
          }

          const nombreActivo = activo?.NombreActivo.toUpperCase() || "";
          const nombre = nombreActivo.length > 55 ? activo?.NombreActivo.substring(0, 55).toUpperCase() : activo?.NombreActivo.toUpperCase()
          const style = nombreActivo.length > 35 ? "infoGeneral2" : "infoGeneral"; 
  
          const CodigoQR = url;
          contenido.push({
            table: { 
              widths: ["*"],
              body: [
                [
                  {
                    image: CodigoQR,
                    width: 290,
                    height: 290,
                    margin: [-18, -25, 0, -18], 
                  },
                ],
                [
                  {
                    text: `${activo.CodigoActivo || ''}`, 
                    margin: [-5, -10, 15, 5], 
                    alignment: 'center',
                    style: "titulo1",
                  },
                ],
                [
                  {
                    text: `${nombre}`,
                    margin: [-5, 0, 10, 0], 
                    style: style,
                  },
                ],
              ],
            },
            layout: {
              defaultBorder: false,
            },
        

          },
          index < selected.length - 1 ? { text: '', pageBreak: 'after' } : null);
        }
        
      );
    })

    const docDefinition = {
      pageSize: {
        width: 288,
        height: 432,
      },
      styles: {
        titulo1: {
          fontSize: 30,
          bold: true,
          alignment: "center",
        },
        infoGeneral: {
          fontSize: 30,
          bold: true,
          alignment: "center",
        },
        infoGeneral2: {
          fontSize: 25,
          bold: true,
          alignment: "center",
        },
      },
      pageMargins: [10, 10, 10, 10],
      content: contenido,
    };

    const doc = pdfMake.createPdf(docDefinition);
    
    doc.getDataUrl((url) => {
      setPdfUrl(url); 
    });
  };

  const GenerarReportePDF4x3 = (selected) => {
    const contenido = [];

    selected.forEach((activo, index) => {
      QRCode.toDataURL(
        `${activo?.CodigoActivo}`,
        { errorCorrectionLevel: "Q" },
        (err, url) => {
          if (err) {
            console.error("Error generando el código QR:", err);
            return;
          }

          const nombreActivo = activo?.NombreActivo.toUpperCase() || "";
          const nombre = nombreActivo.length > 90 ? activo?.NombreActivo.substring(0, 95).toUpperCase() : activo?.NombreActivo.toUpperCase()
          const style = nombreActivo.length > 24 ? "infoGeneral2" : "infoGeneral"; 
  
          const CodigoQR = url;
          contenido.push({
            table: { 
              widths: ["*"],
              body: [
                [
                  {
                    image: CodigoQR,
                    width: 200,
                    height: 200,
                    margin: [-8, -25, 0, -18], 
                  },
                ],
                [
                  {
                    text: `${activo.CodigoActivo || ''}`, 
                    margin: [10, -10, 15, 5], 
                    alignment: 'center',
                    style: "titulo1",
                  },
                ],
                [
                  {
                    text: `${nombre}`,
                    margin: [-5, 0, 10, 0], 
                    style: style,
                  },
                ],
              ],
            },
            layout: {
              defaultBorder: false,
            },
        

          },
          index < selected.length - 1 ? { text: '', pageBreak: 'after' } : null);
        }
        
      );
    })

    const docDefinition = {
      pageSize: {
        width: 216,
        height: 288,
      },
      styles: {
        titulo1: {
          fontSize: 30,
          bold: true,
          alignment: "center",
        },
        infoGeneral: {
          fontSize: 25,
          bold: true,
          alignment: "center",
        },
        infoGeneral2: {
          fontSize: 13,
          bold: true,
          alignment: "center",
        },
      },
      pageMargins: [10, 10, 10, 10],
      content: contenido,
    };

    const doc = pdfMake.createPdf(docDefinition);
    
    doc.getDataUrl((url) => {
      setPdfUrl(url); 
    });
  };

  useEffect(() => {
    if (showDialogQRCode) {
      obtenerInformacion(selected);
    }
  }, [showDialogQRCode]);

  return (
    <Dialog
      visible={showDialogQRCode}
      onHide={onHideReporte}
      style={{ width: "63vw", height: "85vh" }}
    >
      <Loader loading={loading} querySelector={"#Modal"} />
      <div id="Modal">
        {!loading && pdfUrl && (
          <iframe
            src={pdfUrl}
            style={{ width: "60vw", height: "75vh", border: "1px solid #ccc" }}
            id="foo"
            title="Reporte QR PDF"
          />
        )}
      </div>
      
    </Dialog>
  );
};

export default QRCodeModal;
